import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  inventoryTitle: {
    color: theme.palette.basic.black,
    display: "inline-flex",
    fontSize: 20,
  },
  titleText: {
    lineHeight: "40px",
    fontWeight: 500,
    fontSize: 20,
    marginRight: 16,
  },
  locationButton: {
    fontSize: "inherit",
    padding: 0,
    cursor: "pointer",
    color: theme.palette.primary.main,
    "&:hover": {
      opacity: 0.5,
    },
  },
}));
